import { useQuery } from 'react-query';
import {
  getRetailerStoreOpeningHours,
  getRetailerStores,
} from './heroApiClient';

export const useGetRetailerStoreOpeningHours = (storeId?: string) => {
  return useQuery(
    ['getRetailerStoreOpeningHours', storeId],
    () => (storeId ? getRetailerStoreOpeningHours(storeId) : undefined),
    { suspense: true, enabled: Boolean(storeId), staleTime: Infinity },
  );
};

export const useGetRetailerStores = (retailerId: string) => {
  return useQuery(
    ['getRetailerStores', retailerId],
    () => getRetailerStores(retailerId),
    { enabled: Boolean(retailerId) },
  );
};
